import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { Icon, IconSize } from 'app/design-system/components/Icon';
import { ICON_NAME_ACCOUNT, ICON_NAME_SETTINGS_GEAR } from 'app/design-system/constants/IconNames';
import { selectIsLoggedIn } from 'app/redux/selectors/auth';

import DropdownMenu from '../DropdownMenu';
import AuthorizedUserItems from './components/AuthorizedUserItems/AuthorizedUserItems';
import NotAuthorizedUserItems from './components/NotAuthorizedUserItems/NotAuthorizedUserItems';

import styles from './Menu.module.scss';

const Menu: FC = () => {
  const { pathname } = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const isSignedIn = useSelector(selectIsLoggedIn);

  const onToggle = useCallback(() => {
    setIsOpen((currentState) => !currentState);
  }, []);

  const handleCloseMenu = useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleBlur = () => {
    if (isOpen) {
      handleCloseMenu();
    }
  };

  useEffect(() => {
    const splitPath = pathname.split('/');
    const gameIsStarted = Boolean(splitPath[1] === 'external-games' && splitPath[2]);
    if (gameIsStarted) {
      window.addEventListener('blur', handleBlur);
    }
    return () => {
      window.removeEventListener('blur', handleBlur);
    };
  }, [isOpen]);

  const icon = useMemo(() => {
    const iconName = isSignedIn ? ICON_NAME_ACCOUNT : ICON_NAME_SETTINGS_GEAR;

    return (
      <Icon icon={iconName}
            size={IconSize.DEFAULT}
            className={styles.icon} />
    );
  }, [isSignedIn]);

  return (
    <div className={styles.root}>
      <DropdownMenu data-test="headerMenu-dropdownWrapper"
                    headerLabel={icon}
                    onToggle={onToggle}
                    isOpen={isOpen}
                    className={styles.dropdown}>
        {isSignedIn && <AuthorizedUserItems handleCloseMenu={handleCloseMenu} />}
        {!isSignedIn && <NotAuthorizedUserItems handleCloseMenu={handleCloseMenu} />}
      </DropdownMenu>
    </div>
  );
};

export default Menu;
